import { DragRow } from "@progress/kendo-angular-grid";
import { AttachmentStandardColumnNames } from "../../../enums/grid.enums";
import { IGridFlavor } from "../../../interfaces/igrid-flavor.interface";
import { GridConfig } from "../../grid/grid-config.model";
import { GridFlavorBase } from './grid-flavor-base';

export class AttachmentsGridFlavor extends GridFlavorBase implements IGridFlavor {

    constructor() {
        super();
        this.addAdditionalButtons();
    }

    public gridCommandColumnWidth(): number {
        return 150;
    }
    public showGeocodeGrid(apiUrl: string, formFieldId: number): boolean {
        return false;
    }
    public addAnyVirtualColumns(gridConfig: GridConfig): void {
        gridConfig.addVirtualColumnDef(AttachmentStandardColumnNames.Title, 'Title');
        gridConfig.addVirtualColumnDef(AttachmentStandardColumnNames.FileName, 'File Name');
        gridConfig.addVirtualColumnDef(AttachmentStandardColumnNames.FileType, 'File Type');
        gridConfig.addVirtualColumnDef(AttachmentStandardColumnNames.UploadInfo, 'Upload');
        gridConfig.addVirtualColumnDef(AttachmentStandardColumnNames.DownloadInfo, 'Download');
        gridConfig.addVirtualColumnDef(AttachmentStandardColumnNames.Version, 'Version');
        gridConfig.addVirtualColumnDef(AttachmentStandardColumnNames.IsLatest, 'Is Latest');
        gridConfig.addVirtualColumnDef(AttachmentStandardColumnNames.IsDisabled, 'Is Disabled', true);
    }

    public canAddNewRow(): boolean {
        return false;
    }

    public usesButton(button: string, dataItem: any): boolean {
        let rowIsDisabled: boolean = dataItem?.__gridRow?.hshFormInstanceElementsByName[AttachmentStandardColumnNames.IsDisabled]?.standinDisplayValue == "1";
        let initialResult: boolean = super.usesButton(button, rowIsDisabled);
        if (initialResult) {
            if (button == 'disable' && rowIsDisabled) {
                return false;
            } else if (button == 'restore' && !rowIsDisabled) {
                return false;
            } else if (button == 'download' && rowIsDisabled) {
                return false;
            } else if (button == 'upload' && rowIsDisabled) {
                return false;
            } else if (button == 'edit' && rowIsDisabled) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }

    public cannotMoveRowMessage(row: DragRow): string {
        let msg = null;
        let isLatest = row.dataItem[AttachmentStandardColumnNames.IsLatest] == 'true';
        if (!isLatest) {
            msg = "You cannot reposition an earlier version of an attachment, instead reposition the latest version.";
        }
        return msg;
    }

    private addAdditionalButtons() {
        this.gridCommandButtons = this.gridCommandButtons.concat(['disable', 'restore', 'download', 'upload']);
    }

    // By setting Kendo Grid's scrollable property to null we turn off virtual scrolling, but are still able to scroll
    // (Don't want to set it to "none" or the user would be unable to scroll)
    // This became neccessary because of strange behavior on the attachments grid in which if you had to scroll down to a
    // row you couldn't click it to open it for editing. 
    public scrollMode(): string {
        return null;
    }
}
